export const basePath =
  process.env.REACT_APP_BASE_PATH || 'http://localhost:8004';

export const piwikConfig = {
  url: process.env.REACT_APP_PIWIK_URL || 'http://localhost:8004',
  siteId: process.env.REACT_APP_PIWIK_SITE_ID || 12,
  clientTrackerName: 'matomo.js',
  serverTrackerName: 'matomo.php'
};



// WEBPACK FOOTER //
// ./src/config.js